import CommonUtil from "utils/CommonUtil";
import { PageStore } from "common/page/store/PageStore";
import React from "react";
import UIButtonClick from "./UIButtonClick";
import UIButtonLink from "./UIButtonLink";
import { UIButtonProps } from "./UIButton";
import message from "common/message/source/MessageSource";
import { Link, useHistory } from 'react-router-dom';

export interface UIButtonListProps extends UIButtonProps {
  page?: PageStore<any>;
  replace?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export default UIButtonList;

function UIButtonList(props: UIButtonListProps) {
  const { location } = useHistory();
  const label = message.get("common.label.list", "목록");

  if (typeof props.onClick === "function") {
    return <UIButtonClick label={label} {...props} onClick={props.onClick} />;
  }

  if (props.page != null) {
    return <UIButtonClick label={label} {...props} onClick={() => props.page?.replace()} />;
  }

  return <UIButtonLink label={label} {...props} to={CommonUtil.getListPath(location)} />;
}
